module.exports = __webpack_public_path__ + "img/success_icon.9f3f825b.png";